export const configData = {


    INSTANCE: "PILOT",

    LAMBDA_REGION: "us-east-1",//for pilot

    BUCKET_NAME: "mil-nv-dgv2-tduat",// FOR UAT // for TD account 

    // LAMBDA_FUNCTION_NAME: "AG-NG-Findings-DbHelper",
    Function_url:"https://etcm72jxcby6yksgu7t5nyudqq0rmqkf.lambda-url.us-east-1.on.aws/",
    MasterSyncFunction_url:'https://2fokjd7kejtyp4n5u3sa7o7j4q0seyem.lambda-url.us-east-1.on.aws/',
    LAMBDA_FUNCTION_NAME: "frm_db_helper",
    LAMBDA_FUNCTION_NAME1: "DGV2-UIWrapper",
    GET_CLIENT_META_KEY: "GET_CLIENT_META_KEY",
    // Forgot Password
    RECOVER_PASSWORD: "RECOVER_PASSWORD",
    SEND_EMAIL_FOR_RECOVERY: "SEND_EMAIL_FOR_RECOVERY",
    // Reset Password
    RESET_PASSWORD: "RESET_PASSWORD",
    //Dashboard
    GET_DASHBOARD_DATA: "GET_DASHBOARD_DATA",
    GET_FILE_DETAILS_BY_LOAN_GUID: "GET_FILES_DETAILS_BY_LOANGUID",
    GET_USER_DETAILS: "GET_USER_DETAILS",
    GET_USERS_LIST: "GET_USERS_LIST",
    GET_USER_ROLE_RIGHTS_BY_USER_MAPID: "GET_USER_ROLE_RIGHTS_BY_USER_MAPID",
    GET_USER_MAPPING_DETAILS: "GET_USER_MAPPING_DETAILS",
    //Reset Loan
    RESET_LOAN_STATUS: "RESET_LOAN_STATUS",
    // Loan Import Data
    GET_LOAN_IMPORT_FOR_LOAN: "GET_LOAN_IMPORT_FOR_LOAN",
    // DG General Info Section
    GET_GENERAL_INFO_FOR_LOAN: "GET_GENERAL_INFO_FOR_LOAN",
    GET_GENERAL_INFO_DETAILS_FOR_LOAN: "GET_GENERAL_INFO_DETAILS_FOR_LOAN",
    CONDITION_ACTIONS: "CONDITION_ACTIONS",
    RESET_LOS_FLAG: "RESET_LOS_FLAG",
    DELETE_CONDITIONS: "DELETE_CONDITIONS",
    PUBLISH_RESULTS: "PUBLISH_RESULTS",
    PRINT_DG_RESULTS: "PRINT_DG_RESULTS",
    PRINT_WAGE_EARNER: "PRINT_WAGE_EARNER",
    RULE_RESULT_DOWNLOAD: "RULE_RESULT_DOWNLOAD",
    COMPLETE_LOAN: "COMPLETE_LOAN",
    RUN_RULES: "RUN_RULES",
    GET_ONECLICK_LOANGUID: "GET_ONECLICK_LOANGUID",
    GET_USERS_LIST: "GET_USERS_LIST",
    GET_USER_DETAILS: "GET_USER_DETAILS",
    CREATE_USER: "CREATE_USER",
    EDIT_USER_DETAILS: "EDIT_USER_DETAILS",
    ADD_BULK_USERS: "ADD_BULK_USERS",
    GET_USER_MAPPING_DETAILS: "GET_USER_MAPPING_DETAILS",
    GET_CONFIG_FOR_UI: "GET_CONFIG_FOR_UI",
    GET_CURRENT_RPM: "GET_CURRENT_RPM",
    SAVE_RPM_DATA: "SAVE_RPM_DATA",
    COPY_FILE_TO_S3: "COPY_FILE_TO_S3",
    GET_CLIENT_USECASE_INFO: "GET_CLIENT_USECASE_INFO",
    ADD_NEW_FORM_FIELDSINFO_FOR_TEMPLATE: "ADD_NEW_FORM_FIELDSINFO_FOR_TEMPLATE",
    RULES_FIELDINFO_FOR_TEMPLATE: "RULES_FIELDINFO_FOR_TEMPLATE",
    GET_CONFIGURED_RULE_VERSION_INFO: "GET_CONFIGURED_RULE_VERSION_INFO",
    GET_ROLES_RIGHTS: "GET_ROLES_RIGHTS",
    GET_MANAGE_ROLES_RIGHTS: "GET_MANAGE_ROLES_RIGHTS",
    ADD_ROLES_RIGHTS: "ADD_ROLES_RIGHTS",
    SAVE_EXCEL_RULE_VERSION_CONFIG: "SAVE_EXCEL_RULE_VERSION_CONFIG",
    ENABLE_RPM_FOR_SELECTED_VERSION: "ENABLE_RPM_FOR_SELECTED_VERSION",
    RULE_TEMPLATE_DOWNLOAD: "RULE_TEMPLATE_DOWNLOAD",
    MERGE_RULE_TEMPLATE: "MERGE_RULE_TEMPLATE",
    LOGOUT_USER: "LOGOUT_USER",
    UPDATE_CLIENT_MASTER_JSON: 'UPDATE_CLIENT_MASTER_JSON',
    CREATE_MODIFY_USER_MAPPING: "CREATE_MODIFY_USER_MAPPING",
    DELETE_USER_MAPPING: "DELETE_USER_MAPPING",
    EDIT_DELETE_ROLES_RIGHTS: "EDIT_DELETE_ROLES_RIGHTS",
    GET_ROLES_RIGHTS: "GET_ROLES_RIGHTS",
    GET_MANAGE_ROLES_RIGHTS: "GET_MANAGE_ROLES_RIGHTS",
    ADD_ROLES_RIGHTS: "ADD_ROLES_RIGHTS",
    EDIT_DELETE_ROLES_RIGHTS: "EDIT_DELETE_ROLES_RIGHTS",
    UPDATE_MANAGE_ROLES_RIGHTS: "UPDATE_MANAGE_ROLES_RIGHTS",
    // NEWIDXDEVURL:"http://mil-og-gdx-web-host.s3-website-us-west-2.amazonaws.com/dgtreeview"
    NEWIDXDEVURL: "https://idxtduat.indecomm.net/dgtreeview"
    
    // NEWIDXDEVURL: "http://localhost:3001/dgtreeview"
}